import React, { useEffect, useRef } from 'react';
import './project.css';
import TargetLanding from './TargetLanding';
import PikachuGame from './PikachuGame.jsx';
import TargetApp from './TargetApp.jsx';
import ButterFly from './ButterFly.jsx';
import ToDo from './ToDo.jsx';
import Sanctuary from './Sanctuary.jsx';

const ProjectDrawer = ({ project, onClose }) => {
    const drawerRef = useRef(null);

    useEffect(() => {
        if (project) {
            setTimeout(() => {
                drawerRef.current.classList.add('drawer-open');
            }, 10);
            document.body.style.overflow = 'hidden';
        } else {
            if (drawerRef.current) {
                drawerRef.current.classList.remove('drawer-open');
            }
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [project]);

    if (!project) return null;

    const renderProjectContent = () => {
        switch (project.id) {
            case 1:
                return <TargetApp />;
            case 2:
                return <ButterFly/>
            case 3:
                return <ToDo/>
            case 4:
                return <PikachuGame />;
            case 5:
                return <TargetLanding />;
            case 6:
                return <Sanctuary />;
            default:
                return (
                    <div className="default-project-content">
                        <h2 className="drawer-title">{project.title}</h2>
                        <img src={project.image} alt={project.title} className="drawer-image" />
                        <p><strong>Category:</strong> {project.category.join(', ')}</p>
                        <div className="drawer-links">
                            {project.url && <a href={project.url} target="_blank" rel="noreferrer" className="live-link">🔗 Live</a>}
                            {project.repositoryUrl && <a href={project.repositoryUrl} target="_blank" rel="noreferrer" className="code-link">💻 GitHub</a>}
                        </div>
                    </div>
                );
        }
    };

    return (
        <div className={`drawer-overlay ${project ? 'overlay-visible' : ''}`} onClick={onClose}>
            {/* Floating Close Button (outside the drawer) */}
            <button className="drawer-close-floating" onClick={onClose}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" />
                    <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" />
                </svg>
            </button>

            {/* Drawer Card */}
            <div
                ref={drawerRef}
                className="drawer-content"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="drag-handle"></div>
                {renderProjectContent()}
            </div>
        </div>
    );
};

export default ProjectDrawer;
